import { render } from "./ScoreboardView.vue?vue&type=template&id=4edd08c8&scoped=true"
import script from "./ScoreboardView.vue?vue&type=script&lang=js"
export * from "./ScoreboardView.vue?vue&type=script&lang=js"

import "./ScoreboardView.vue?vue&type=style&index=0&id=4edd08c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edd08c8"]])

export default __exports__